export const contactButtonStyles = {
  display: "flex",
  justifyContent: "start",
  color: "inherit",
  fontSize: "inherit",
  mt: 5,
  mb: 1,
  paddingY: 0,
  paddingX: 0.5,
  "& .MuiButton-startIcon": {
    backgroundColor: "#ffecde",
    borderRadius: 2,
    width: "44px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translateY(-4px)",
    marginRight: 2.25,
  },
  "& svg": {
    width: 32,
    height: 32,
  },
}
